import DeleteIcon from '@mui/icons-material/Delete';

export const RemoveTimeTrackingIcon = DeleteIcon;
